<template>
<div>
    <div class="dashboard-filter-container">
        <div class="overview-filters d-flex justify-content-between">
            <div v-if="!countriesLoading" class="flex">
                <base-input label="Country" placeholder="Country">
                <b-dropdown  text="Select one to add" variant="outline-light" >
                    <b-dropdown-item v-for="(country,index) in countries" :key="name+index+'_popsitecountry'" @click="addCountryToFilter(index)">{{country}}</b-dropdown-item>
                    <b-dropdown-item @click="addCountryToFilter('all')">All countries</b-dropdown-item>
                </b-dropdown>
                    
                </base-input>
                <template v-if="countrySelected">
                    <div class="badge badge-primary d-inline-flex align-items-center mr-1" v-for="(v,k) in filters.country__in" :key="name+k+'_countrybtn'">
                        {{countries[v]}}
                        <span class="closebtn" @click="deleteCountryFromFilter(k)">&times;</span>
                    </div>
                </template>
            </div>
            <template v-else>Countries loading...</template>
            <template v-if="countrySelected">
                <div class="flex flex-col">
                    <base-input label="Type" placeholder="Type">
                        <b-dropdown text="Select a type to add" variant="outline-light" class="m-2">
                            <b-dropdown-item v-for="(type,index) in popularitySiteTypes" :key="index+'_popsitetype'" @click="addToFilter('type__in',Number(index))">{{type}}</b-dropdown-item>
                        </b-dropdown>
                    </base-input>
                    <template v-if="filters.type__in!==undefined && filters.type__in.length>0">
                        <div class="badge badge-primary d-inline-flex align-items-center mr-1" v-for="(v,k) in filters.type__in" :key="name+'_type_filter_elem'+k">
                            {{popularitySiteTypes[v]}}
                            <span class="closebtn" @click="deleteFromFilter('type__in',k)">&times;</span>
                        </div>
                    </template>
                </div>
                <div class="flex flex-col">
                    <base-input label="City" 
                                placeholder="City" 
                                v-model="filterInputs.city" 
                                @input="autocomplete('city','city__icontains',['country__in'])" 
                                @focus="autocomplete('city','city__icontains',['country__in']);autocompleteData.city.show=true;$forceUpdate()" 
                                @focusout="closeAutocomplete('city')" />
                    
                    <b-card no-body v-if="autocompleteData.city.show && !autocompleteData.city.loading">
                        <b-card-body
                            :id="name+'-city-autocomplete'"
                            ref="content"
                            style="position:relative; height:300px; overflow-y:scroll;"
                        >
                            <div class="autocomplete-container">
                                <base-button class="autocomplete-item" 
                                             type="secondary" 
                                             v-for="(value,index) in autocompleteData.city.data" 
                                             :key="index+'_city_autocomplete'" 
                                             @click="addToFilter('city__in',value)">
                                             {{value}}
                                </base-button>
                            </div>
                        </b-card-body>
                    </b-card>
                    <template v-if="filters.city__in!==undefined && filters.city__in.length>0">
                        <div class="badge badge-primary d-inline-flex align-items-center mr-1" v-for="(v,k) in filters.city__in" :key="name+'_city_filter_elem'+k">
                            {{v}}
                            <span class="closebtn" @click="deleteFromFilter('city__in',k)">&times;</span>
                        </div>
                    </template>
                </div>
            </template>
            
        </div>
        <template v-if="countrySelected">
            <div class="overview-filters d-flex justify-content-between">
                <div class="flex flex-col">
                    <base-input label="Name" 
                                placeholder="Name" 
                                v-model="filterInputs.name" 
                                @input="autocomplete('name','name__icontains',['country__in','city__in','type__in'])" 
                                @focus="autocomplete('name','name__icontains',['country__in','city__in','type__in']);autocompleteData.name.show=true;$forceUpdate()"
                                @focusout="closeAutocomplete('name')" />
                    
                    <b-card no-body v-if="autocompleteData.name.show && !autocompleteData.name.loading">
                        <b-card-body
                            :id="name+'-name-autocomplete'"
                            ref="content"
                            style="position:relative; height:300px; overflow-y:scroll;"
                        >
                            <div class="autocomplete-container">
                                <base-button class="autocomplete-item" 
                                            type="secondary" 
                                            v-for="(value,index) in autocompleteData.name.data" 
                                            :key="index+'_name_autocomplete'" 
                                            @click="addToFilter('name__in',value)">
                                    {{value}}
                                </base-button>
                            </div>
                        </b-card-body>
                    </b-card>
                    <template v-if="filters.name__in!==undefined && filters.name__in.length>0">
                        <div class="badge badge-primary d-inline-flex align-items-center mr-1" v-for="(v,k) in filters.name__in" :key="name+'_name_filter_elem'+k">
                            {{v}}
                            <span class="closebtn" @click="deleteFromFilter('name__in',k)">&times;</span>
                        </div>
                    </template>
                </div>
                <div class="flex flex-col">
                    <base-input label="Google name" 
                                placeholder="Google name" 
                                v-model="filterInputs.google_name" 
                                @input="autocomplete('google_name','google_name__icontains',['country__in','city__in','type__in'])" 
                                @focus="autocomplete('google_name','google_name__icontains',['country__in','city__in','type__in']);autocompleteData.google_name.show=true;$forceUpdate()" 
                                @focusout="closeAutocomplete('google_name')" />
                    
                    <b-card no-body v-if="autocompleteData.google_name.show && !autocompleteData.google_name.loading">
                        <b-card-body
                            :id="name+'-google_name-autocomplete'"
                            ref="content"
                            style="position:relative; height:300px; overflow-y:scroll;"
                        >
                            <div class="autocomplete-container">
                                <base-button class="autocomplete-item" 
                                            type="secondary" 
                                            v-for="(value,index) in autocompleteData.google_name.data" 
                                            :key="index+'_google_name_autocomplete'" 
                                            @click="addToFilter('google_name__in',value)">
                                
                                            {{value}}
                                
                                </base-button>
                            </div>
                        </b-card-body>
                    </b-card>
                    <template v-if="filters.google_name__in!==undefined && filters.google_name__in.length>0">
                        <div class="badge badge-primary d-inline-flex align-items-center mr-1" v-for="(v,k) in filters.google_name__in" :key="name+'_google_name_filter_elem'+k">
                            {{v}}
                            <span class="closebtn" @click="deleteFromFilter('google_name__in',k)">&times;</span>
                        </div>
                    </template>
                </div>
                <div class="flex flex-col">
                    <base-input label="Place ID" 
                                placeholder="Place ID" 
                                v-model="filterInputs.place_id" 
                                @input="autocomplete('place_id','place_id__icontains',['country__in','city__in','type__in'])" 
                                @focus="autocomplete('place_id','place_id__icontains',['country__in','city__in','type__in']);autocompleteData.place_id.show=true;$forceUpdate()" 
                                @focusout="closeAutocomplete('place_id')" />
                    
                    <b-card no-body v-if="autocompleteData.place_id.show && !autocompleteData.place_id.loading">
                        <b-card-body
                            :id="name+'-place_id-autocomplete'"
                            ref="content"
                            style="position:relative; height:300px; overflow-y:scroll;"
                        >
                            <div class="autocomplete-container">
                                <base-button class="autocomplete-item" type="secondary" 
                                            v-for="(value,index) in autocompleteData.place_id.data" 
                                            :key="index+'_place_id_autocomplete'" 
                                            @click="addToFilter('place_id__in',value)">
                                    {{value}}
                                </base-button>
                            </div>
                        </b-card-body>
                    </b-card>
                    <template v-if="filters.place_id__in!==undefined && filters.place_id__in.length>0">
                        <div class="badge badge-primary d-inline-flex align-items-center mr-1" v-for="(v,k) in filters.place_id__in" :key="name+'_place_id_filter_elem'+k">
                            {{v}}
                            <span class="closebtn" @click="deleteFromFilter('place_id__in',k)">&times;</span>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <div v-if="countrySelected" class="overview-filters d-flex justify-content-between">
            <base-input label="Start date" placeholder="Start date" :appendIcon="'ni ni-calendar-grid-58 text-blue'">
                <date-picker v-model="filters.create_date__gte" :config="datePickerOptions" @dp-change="emitChange()"/>
            </base-input>
            <base-input label="End date" placeholder="End date" :appendIcon="'ni ni-calendar-grid-58 text-blue'">
                <date-picker v-model="filters.create_date__lte" :config="datePickerOptions" @dp-change="emitChange()"/>
            </base-input>

        </div>
    </div>
</div>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';

const PopularitySiteRepository = RepositoryFactory.get('popularity_site')
const CountryRepository = RepositoryFactory.get('country')

export default {
    name:'popularity-filters',
    props:{
        name:String,
    },
    data(){
        return {
            filters:{
                create_date__gte:new Date(new Date().getTime() - (24*60*60*1000) * 7), // 1 hafta öncesinin tarihi
                create_date__lte:new Date(), // Bugün
            },
            filterInputs:{}, // İnputları tuttuğumuz yer

            autocompleteFields:[
                'name',
                'google_name',
                'place_id',
                'city',
                'type',
            ],

            datePickerOptions:{
                format: 'MM/DD/YYYY',
                useCurrent: false,
                showClear: true,
                showClose: true,
                showTodayButton:true,
            },

            autocompleteData:{},
            focusedField:null,

            countries:null,
            countriesLoading:true,
            countrySelected:false,
        }
    },
    created(){
        this.emitChange();
        this.getCountries();
    },
    methods:{
        getCountries(){
            this.countriesLoading=true;
            CountryRepository.get().then((response) => {
                var data=response.data;
                this.countries={};
                for(var i in data){
                    var d=data[i]
                    this.countries[d.id]=d.name
                }
                this.countriesLoading=false;
            })
        },
        resetAutocompleteData(){
            for(var i in this.autocompleteFields){
                var fieldName=this.autocompleteFields[i];
                this.autocompleteData[fieldName]={
                    data:undefined,
                    timer:undefined,
                    show:false,
                    loading:false,
                }
            }
        },
        addCountryToFilter(countryId){
            if(this.filters.country__in===undefined){
                this.filters.country__in=[]
            }
            if(countryId==='all'){
                for(var i in this.countries){
                    if(this.filters.country__in.includes(Number(i)))
                        continue
                    this.filters.country__in.push(Number(i));
                }
            }
            else{
                if(this.filters.country__in.includes(Number(countryId)))
                    return
                this.filters.country__in.push(Number(countryId));
            }
            this.countrySelected=true;
            this.resetAutocompleteData();
            this.emitChange();
        },
        deleteCountryFromFilter(index){
            this.filters.country__in.splice(index,1);
            if(this.filters.country__in.length === 0){
                this.countrySelected=false;
                this.resetAutocompleteData();
                this.filters={};
            }
            this.emitChange();
        },
        addToFilter(fieldName,value){
            if(this.filters[fieldName]===undefined){
                this.filters[fieldName]=[];
            }
            if(this.filters[fieldName].includes(value))
                return;
            this.filters[fieldName].push(value);
            this.emitChange();
        },
        deleteFromFilter(fieldName,index){
            this.filters[fieldName].splice(index,1);
            if(this.filters[fieldName].length === 0){
                delete this.filters[fieldName]
            }
            this.emitChange();
        },
        autocomplete(fieldName,filterName,filterList){
            this.autocompleteData[fieldName].loading=true;
            clearTimeout(this.autocompleteData[fieldName].timer);
            this.autocompleteData[fieldName].data=undefined;

            // var filters=this.copyObject(this.filters);
            var filters={};

            for(var i in filterList){
                var autocompleteFilterName=filterList[i];
                if(this.filters[autocompleteFilterName]!==undefined){
                    filters[autocompleteFilterName]=this.filters[autocompleteFilterName]
                }
            }

            var fieldValue=this.filterInputs[fieldName]
            if(fieldValue!==undefined){
                filters[filterName]=fieldValue
            }

            for(var i in filters){
                if(i.startsWith('create_date')){
                    delete filters[i];
                }
            }
            this.autocompleteData[fieldName].timer = setTimeout(() => {
                var payload={
                    filters:filters,
                    field:fieldName
                }
                PopularitySiteRepository.autocomplete(payload).then((response) => {
                    this.autocompleteData[fieldName].data=response.data;
                    this.autocompleteData[fieldName].loading=false;
                    this.$forceUpdate();
                })
            },500)
        },
        closeAutocomplete(fieldName){
            setTimeout(() => {
                this.autocompleteData[fieldName].show=false;
                this.$forceUpdate();
            },250)
        },
        parseDates(filters){
            var dateFilterNames=['create_date__gte','create_date__lte'];
            for(var i in dateFilterNames){
                var filterName=dateFilterNames[i]
                if(filters[filterName]===null || filters[filterName]===undefined){
                    delete filters[filterName]
                }
                else{
                    var dateVal=new Date(filters[filterName]);
                    filters[filterName]=`${dateVal.getFullYear()}-${('0' + (dateVal.getMonth()+1)).slice(-2)}-${('0' + (dateVal.getDate())).slice(-2)}`;
                }
                
            }
            return filters
        },
        emitChange(){
            this.$forceUpdate();
            var filters=this.parseDates(this.copyObject(this.filters));
            this.$emit('change',{name:this.name,filters:filters});
        }
    }
}
</script>

<style>

.overview-filters{
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.dashboard-filter-container{
  display:flex;
  flex-direction: column;
  gap:5px
}

.autocomplete-container{
  display:flex;
  flex-direction: column;
}

</style>